import getters from './getters'
import actions from './actions'
import mutations from './mutations'

export default {
  namespaced: true,
  state: {
    unitNatureEnum: [
      {label: '国家行政企业', value: '1'},
      {label: '公私合作企业', value: '2'},
      {label: '民营企业', value: '3'},
      {label: '社会组织机构', value: '4'},
      {label: '中外合资企业', value: '5'},
      {label: '外资企业', value: '6'},
    ],
    registerTypeEnum: [
      {label: '国有企业', value: 1},
      {label: '民营企业', value: 2},
      {label: '有限责任公司', value: 3},
      {label: '股份有限公司', value: 4},
      {label: '港、澳、台商投资企业', value: 5},
      {label: '中外合资企业', value: 6},
      {label: '外资企业', value: 7},
    ],
    companyScaleEnum: [
      {label: '大', value: 1},
      {label: '中', value: 2},
      {label: '小', value: 3},
      {label: '微', value: 4},
    ],
    couponFlagEnum: [
      {label: '是', value: 1},
      {label: '不是', value: 0},
    ],
    couponFlagViewEnum: [
      {label: '未申请', value: 0},
      {label: '已申请', value: 1},
      {label: '申请拒绝', value: 2},
      {label: '申请通过', value: 3},
    ],
    auditStateEnum: [
      {label: '待审核', value: 1},
      {label: '已通过', value: 3},
      {label: '已拒绝', value: 2},
    ],
    orgArea: [
      {label: '船山区', value: 2585},
      {label: '经开区', value: 3513},
      {label: '河东新区', value: 3512},
      {label: '高新区', value: 3514},
      {label: '安居区', value: 2586},
      {label: '射洪市', value: 2588},
      {label: '大英县', value: 2589},
      {label: '蓬溪县', value: 2587},
      {label: '其他', value: -1},
    ]
  },
  getters,
  actions,
  mutations,
}



// WEBPACK FOOTER //
// ./src/store/modules/organization/index.js